import { restaurantAdmin, superAdmin } from "@components/membership/const/userRole";
import Layout from "@layout/Layout";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import ProtectedRoute from "../layout/ProtectedRoute";

const AdministrationPage = lazy(() => import("../pages/AdministrationPage"));
const OrderListPage = lazy(() => import("../order/pages/OrderListPage"));
const UserPage = lazy(() => import("../user/pages/UserPage"));
const UserListPage = lazy(() => import("../user/users/pages/UserListPage"));
const RestaurantListPage = lazy(() => import("../restaurant/pages/RestaurantListPage"));
const RestaurantReportPage = lazy(() => import("../restaurant/pages/RestaurantReportPage"));
const RestaurantEditViewPage = lazy(() => import("../restaurant/pages/RestaurantEditViewPage"));
const PasswordRecoveryListPage = lazy(() => import("../user/password-recovery/pages/PasswordRecoveryListPage"));

let Route: RouteObject = {
    element: <Layout isProtected />,
    children: [
        {
            path: "/administration",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin, restaurantAdmin]}>
                    <AdministrationPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/restaurant/list",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin, restaurantAdmin]}>
                    <RestaurantListPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/restaurant/:restaurantId/report",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin, restaurantAdmin]}>
                    <RestaurantReportPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/restaurant/:restaurantId/edit",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin, restaurantAdmin]}>
                    <RestaurantEditViewPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/order/list",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin, restaurantAdmin]}>
                    <OrderListPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/users",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin]}>
                    <UserPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/users/detail",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin]}>
                    <UserListPage />
                </ProtectedRoute>
            ),
        },
        {
            path: "/administration/users/password-recovery",
            element: (
                <ProtectedRoute allowedRoles={[superAdmin]}>
                    <PasswordRecoveryListPage />
                </ProtectedRoute>
            ),
        },
    ],
}

export default Route;
